<template>
  <div class="main">
    <!-- 进度条 -->
    <div class="progress_view">
      <p>共{{ planNum }}道题</p>
      <div class="progress">
        <p class="progress_title">{{ userAbswerArr.length }}/{{ planNum }}</p>
        <div class="Progress">
          <div class="piece" :style="'width:' + ProgressBar() + '%'">
            <!-- <span>{{ planNum}}</span> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 做题 -->
    <div class="content_view" v-loading="loading">
      <div class="content_left">
        <div v-for="(item, index) in answerArr" :key="index">
          <Atest
            v-if="item.Type == 'ATEST' && anIndex == index"
            :TestItems="item"
            :anIndex="anIndex"
            :userAbswerArr="userAbswerArr"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
          <Xtest
            v-else-if="item.Type == 'XTEST' && anIndex == index"
            ref="xtest"
            :TestItems="item"
            :anIndex="anIndex"
            :userAbswerArr="userAbswerArr"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
          <Tktest
            v-else-if="item.Type == 'TKTEST' && anIndex == index"
            ref="tktest"
            :TestItems="item"
            :userAbswerArr="userAbswerArr"
            :anIndex="anIndex"
            :practice="practice"
            :handState="handState"
            @userAbswer="saveAnswer"
          />
          <Pdtest
            v-else-if="item.Type == 'PDTEST' && anIndex == index"
            :TestItems="item"
            :userAbswerArr="userAbswerArr"
            :anIndex="anIndex"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
          <Jdtest
            v-else-if="item.Type == 'JDTEST' && anIndex == index"
            ref="jdtest"
            :TestItems="item"
            :userAbswerArr="userAbswerArr"
            :anIndex="anIndex"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
          <A3test
            v-else-if="item.Type == 'A3TEST' && anIndex == index"
            ref="a3test"
            :TestItems="item"
            :userAbswerArr="userAbswerArr"
            :anIndex="anIndex"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
          <Btest
            v-else-if="item.Type == 'BTEST' && anIndex == index"
            ref="btest"
            :TestItems="item"
            :userAbswerArr="userAbswerArr"
            :anIndex="anIndex"
            :practice="practice"
            @userAbswer="saveAnswer"
          />
        </div>
        <!-- 切换 -->
        <div class="switch_view">
          <div class="switch_left">
            <el-button v-if="anIndex !== 0" @click="anIndexType('0')"
              >上一题</el-button
            >
            <el-button @click="anIndexType('1')">下一题</el-button>
            <el-button v-if="submitBtn()" @click="handSubmit">提交</el-button>
          </div>
          <div class="switch_right">
            <el-button :class="IsFav == 0 ? '' : 'blue'" @click="submitCollect">
              <img src="@/assets/student/collect.png" alt="" />
              收藏</el-button
            >
            <el-button @click="noteState = true">
              <img src="@/assets/student/note.png" alt="" />
              笔记</el-button
            >
          </div>
        </div>
        <!-- 答题解析 -->
        <div class="analysis_view" v-if="analysisState == true">
          <h4>答题解析</h4>
          <div>
            <p>
              正确答案：<span>{{ row.Answer }}</span>
            </p>
            <p>
              我的答案：<span>{{ row.UserAnswer }}</span>
            </p>
          </div>
          <p><span>解析：</span>{{ row.Explain ? row.Explain : "略" }}</p>
        </div>
        <!-- 我的笔记 -->
        <div class="note_view" v-if="noteState == true">
          <h4>我的笔记</h4>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="userNote"
            maxlength="150"
            show-word-limit
          >
          </el-input>
          <div>
            <p>限150个字</p>
            <el-button type="primary" @click="submitNote">提交</el-button>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->
      <div class="content_right">
        <div class="botton_view">
          <el-button type="primary" @click="exitBtn">返回列表</el-button>
          <el-button type="danger" @click="againAnswer">重做</el-button>
          <el-button type="success" @click="readOver">批阅</el-button>
        </div>
        <div class="answer_sheet">
          <p>答题卡</p>
          <div class="answer_list" ref="alist">
            <ul class="answer_view" ref="answer">
              <li
                v-for="(item, index) in subjectArr"
                :key="index"
                class="answer_card"
              >
                <p><span></span>{{ item.Style }}</p>
                <div class="box_view">
                  <div
                    class="box"
                    v-for="(zitem, zindex) in item.dataInfo"
                    :key="zindex"
                    :class="questionCard(zitem)"
                    @click="cardSwitch(zitem)"
                  >
                    {{ zitem.sujectIndex }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- <div class="pagination">
            <el-pagination
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="eachPageNum"
              :total="total"
            >
            </el-pagination>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
import { numberChinese } from "@/utils/Theletter.js";
import Atest from "../../examination/components/Atest.vue"; // A题型
import Xtest from "../../examination/components/Xtest.vue"; // X题型
import Tktest from "../../examination/components/Tktest.vue"; // 填空题
import Pdtest from "../../examination/components/Pdtest.vue"; // 判断题
import Jdtest from "../../examination/components/Jdtest.vue"; // 名词解释 || 问答题
import A3test from "../../examination/components/A3test.vue"; // A3题型
import Btest from "../../examination/components/Btest.vue"; // B题型 C题型
import { practiceWithData, facilityHandleata,todealWithData } from "@/utils/topicImg"; // 题型图片处理
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      answerArr: [],
      planNum: 0, // 总数
      completeNum: 0, // 当前
      anIndex: 0, // 当前显示的题目
      userAbswerArr: [], // 答案综合
      userNote: "", // 笔记
      noteState: false, // 笔记状态
      analysisState: false, // 解析状态触发
      row: {}, // 当前数据
      IsFav: 0, // 0未收藏 1收藏
      practice: true, // 练习状态
      userAnswerObj: null, // 参数
      UserAnswer: null,
      handState: false,
      loading: false,
      testList: [],
      total: 10,
      subjectArr: [],
      pageIndex: 1,
      eachPageNum: 10, //当前也多少条数。
      currentData: [], // 当前页数据
      top: 0,
      timer: null,
      count: 0,
    };
  },
  components: {
    Atest,
    Xtest,
    Tktest,
    Pdtest,
    Jdtest,
    A3test,
    Btest,
  },
  props: ["cutcoms"],
  methods: {
    async init() {
      await this.getDatalist();
      await this.getDataRecord();
    },
    // 退出
    exitBtn() {
      this.cutcoms(0);
      this.$destroy();
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.eachPageNum = val;
    },
    handleCurrentChange(val) {
      if (val == 1) {
        this.$refs.answer.style.top = 0;
      } else if (val >= 2) {
        //484 184
        const num = (val - 1) * 474;
        this.$refs.answer.style.top = `-${num}px`;
      }
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
    },
    // 获取题
    async getDatalist() {
      this.loading = true;
      const obj = {
        paperID: this.$parent.rowObj.PaperID,
        examID: this.$parent.rowObj.ExamID,
        AppSource: "ykl",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        // hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await ksPcApi.getPaper(obj);
      if (data.Status == 200) {
        this.creditRecord() // 培训创建的调取保存记录学分
        // 此处与考试数据结构不同
        setTimeout(() => {
          this.loading = false;
        }, 500);
        data.Data.testList.forEach((item) => {
          item.TestItems = item.TestList;
          if (item.TestItems.length) {
            item.TestItems.forEach((zitem) => {
              zitem.A3TestItems = zitem.A3TestItem;
              zitem.BTestItems = zitem.BTestItem;
              if (zitem.SelectedItem) {
                zitem.SelectedItems = zitem.SelectedItem.map((sitem, index) => {
                  let obj = {
                    ItemName: numberChinese(index),
                    Content: sitem,
                  };
                  return obj;
                });
              } else {
                // console.log(zitem.A3TestItem, "空的");
                if (zitem.A3TestItem) {
                  zitem.A3TestItem.forEach((oitem) => {
                    if (Array.isArray(oitem.Answer) == true) {
                      oitem.Answer = oitem.Answer.join();
                    }
                    oitem.SelectedItems = oitem.SelectedItem.map(
                      (kitem, index) => {
                        let obj = {
                          ItemName: numberChinese(index),
                          Content: kitem,
                        };
                        return obj;
                      }
                    );
                  });
                } else if (zitem.BTestItem) {
                  zitem.BTestItem.forEach((oitem) => {
                    if (Array.isArray(oitem.Answer) == true) {
                      oitem.Answer = oitem.Answer.join();
                    }
                    oitem.BTestItems = oitem.SelectedItem.map(
                      (kitem, index) => {
                        let obj = {
                          ItemName: numberChinese(index),
                          Content: kitem,
                        };
                        return obj;
                      }
                    );
                  });
                }
              }
            });
          }
        });
        // console.log(data.Data.testList, "data.Data.testList");
        this.testList = data.Data.testList;
        data.Data.StyleItems = data.Data.testList;
        // let arr = practiceWithData(data.Data)
        // this.answerArr = this.arrayTransfer(arr) // 烂数据处理
        
        this.answerArr = todealWithData(data.Data); // 数据题型格式处理
        console.log(this.answerArr);
        
        this.total = this.answerArr.length;
        this.subjectArr = this.subjectCardClassify(this.answerArr);
        this.planNum = this.answerArr.length; // 题目的长度用于答题卡页面渲染
        this.row = this.answerArr[0];
        this.getNoteCollect();
      } else {
        this.$message.error(data.data);
      }
    },
    arrayTransfer(arr) {
      const result = Object.values(
        arr.reduce((acc, cur) => {
          const { Style, ...rest } = cur;
          if (acc[Style]) {
            acc[Style].children.push(rest);
          } else {
            acc[Style] = { Style, children: [rest] };
          }
          return acc;
        }, {})
      );
      let newarr = []
      result.forEach(item=>{
        item.children.forEach(zitem=>{
          zitem.Style = item.Style
          newarr.push(zitem)
        })
      })
      return newarr
    },

    // 题卡归类
    subjectCardClassify(nwearr) {
      // this.subjectArr =
      // console.log(this.arrayTransfer(arr));
      // let nwearr = this.arrayTransfer(arr)
      // console.log(nwearr, "newarr");
      nwearr.forEach((item, index) => {
        item.sujectIndex = index + 1;
      });
      let tempArr = [];
      let Data = [];
      for (let i = 0; i < nwearr.length; i++) {
        if (tempArr.indexOf(nwearr[i].Style) === -1) {
          Data.push({
            Style: nwearr[i].Style,
            dataInfo: [nwearr[i]],
          });
          tempArr.push(nwearr[i].Style);
        } else {
          for (let j = 0; j < Data.length; j++) {
            if (Data[j].Style == nwearr[i].Style) {
              Data[j].dataInfo.push(nwearr[i]);
              break;
            }
          }
        }
      }
      return Data;
    },
    // 批阅
    readOver() {
      const num = this.userAbswerArr.filter((item) => {
        return item.IsRight == true;
      });
      this.$alert(
        `答对：${num.length}  答错：${this.answerArr.length - num.length}`,
        "练习统计",
        {
          confirmButtonText: "确定",
          callback: (action) => {},
        }
      );
    },
    // 重新答题
    againAnswer() {
      this.$confirm("是否重做练习？点击确定后将清空做题记录", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const obj = {
            examID: this.$parent.rowObj.ExamID,
          };
          const { data } = await ksPcApi.delete_pratice_all(obj);
          if (data.Status == 200) {
            this.analysisState = false;
            this.userAbswerArr = [];
            this.answerArr = [];
            this.anIndex = 0;
            this.init();
          } else {
            this.$message.error(data.Data);
          }
        })
        .catch(() => {});
    },
    // 点击收藏
    async submitCollect() {
      const obj = {
        IsFav: this.IsFav == 0 ? 1 : 0, // 1收藏
        TestID: this.row.TestID,
        ChildTestID: this.row.ChapterID,
        AppID: this.row.AppID,
        ChapterID: this.row.ChapterID,
        StyleID: this.row.StyleID,
      };
      const { data } = await ksPcApi.collectApi(obj);
      if (data.Status == 200) {
        this.$message({
          message: data.data,
          type: "success",
        });
        this.getNoteCollect();
      } else {
        this.$message.error(data.Data);
      }
    },
    // 提交笔记
    async submitNote() {
      const obj = {
        TestID: this.row.TestID,
        ChildTestID: this.row.ChapterID,
        AppID: this.row.AppID,
        ChapterID: this.row.ChapterID,
        StyleID: this.row.StyleID,
        Context: this.userNote,
      };
      const { data } = await ksPcApi.saveNote(obj);
      if (data.Status == 200) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        // this.getNoteCollect();
      } else {
        this.$message.error(data.Data);
      }
    },
    // 获取答题记录
    async getDataRecord() {
      const obj = {
        examID: this.$parent.rowObj.ExamID,
        AppSource: "ykl",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const { data } = await ksPcApi.practice_Answer_LIst(obj);
      if (data.Status == 200) {
        this.answerArr.forEach((item) => {
          data.Data.forEach((zitem) => {
            if (item.PaperTestID == zitem.PaperTestID) {
              if (item.Type === "A3TEST" || item.Type === "BTEST") {
                if (item.ID == zitem.ChildTestID) {
                  zitem.TestID = item.TestID;
                  item.UserAnswer = zitem.Answer;
                }
              } else {
                zitem.TestID = item.TestID;
                item.UserAnswer = zitem.Answer;
              }
            }
          });
        });
        this.userAbswerArr = data.Data.map((item) => {
          const obj = {
            TestID: item.TestID,
            ChildTableID: item.ChildTableID,
            UserAnswer: item.Answer,
            Score: null,
            IsRight: item.IsRight,
          };
          return obj;
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    // 答案
    saveAnswer(a) {
      this.row.UserAnswer = a.UserAnswer;
      this.userAnswerObj = a;
      if (this.userAbswerArr.length == 0) {
        this.userAbswerArr.push(a);
      } else {
        const index = this.userAbswerArr.findIndex((item) => {
          // if(item.TestID == item.TestID && item.ChildTableID === a.ChildTableID){
          //   return item
          // }
          return (
            item.TestID == a.TestID && item.ChildTableID === a.ChildTableID
          );
        });
        if (index !== -1) {
          // 选择新答案的时候，删除之前的就答案
          this.userAbswerArr.splice(index, 1);
        }
        this.userAbswerArr.push(a);
        // 过滤掉填空题做了又删的情况
        this.userAbswerArr = this.userAbswerArr.filter((item) => {
          return item.UserAnswer != null;
        });
      }
      this.submitAnswer();
      return;
      if (
        this.row.Type == "ATEST" ||
        this.row.TestType == "ATEST" ||
        this.row.TestType == "PDTEST"
      ) {
        this.submitAnswer();
      }
    },
    // 切换上一题下一题
    anIndexType(type) {
      this.analysisState = false;
      this.handState = false;
      this.noteState = false;
      if (type == "0") {
        // 上一题
        if (this.anIndex <= 0) {
          this.$message({
            message: "警告，当前已经是第一题",
            type: "warning",
          });
        } else {
          this.anIndex--;
        }
      } else if (type == "1") {
        // 下一题
        if (this.anIndex >= this.answerArr.length - 1) {
          this.$message({
            message: "警告，当前已经是最后一道题",
            type: "warning",
          });
        } else {
          this.anIndex++;
        }
      }
      this.$nextTick(() => {
        if (
          (this.row.Type == "XTEST" ||
            this.row.Type == "JDTEST" ||
            this.row.Style == "共用题干不定项选择题") &&
          this.row.UserAnswer
        ) {
          this.row.colourState = true;
        }
        this.getNoteCollect();
      });
    },
    // 手动提交
    handSubmit() {
      this.handState = true;
      if (this.row.Type == "TKTEST") {
        this.$refs.tktest[0].saveAnswer();
      } else if (this.row.Type == "JDTEST") {
        this.$refs.jdtest[0].saveAnswer();
      } else if (this.row.Type == "XTEST") {
        this.$refs.xtest[0].saveAnswer();
      } else if (this.row.Type == "A3TEST") {
        this.$refs.a3test[0].saveAnswer();
      } else if (this.row.Type == "BTEST") {
        this.$refs.btest[0].saveAnswer();
      }
    },
    // 提交答案
    async submitAnswer() {
      const obj = {
        IsRight: this.userAnswerObj.IsRight,
        ChildID: this.row.ChildID,
        AppID: this.row.AppID,
        ChapterID: this.userAnswerObj.ChildTableID,
        StyleID: this.row.StyleID,
        TestID: this.userAnswerObj.TestID,
        Answer: this.row.UserAnswer,
        TestType: this.row.Type,
      };
      const obj1 = {
        childTestID: this.userAnswerObj.ChildTableID,
        examID: this.$parent.rowObj.ExamID,
        paperID: this.$parent.rowObj.PaperID,
        paperTestID: this.row.PaperTestID,
        answer: this.row.UserAnswer,
        isRight: this.userAnswerObj.IsRight,
      };
      if (this.userAnswerObj.UserAnswer) {
        if (
          this.row.Type == "XTEST" ||
          this.row.Type == "JDTEST" ||
          this.row.Style == "共用题干不定项选择题"
        ) {
          // 填空题
          this.row.colourState = true;
        }
        const { data } = await ksPcApi.record_practice_log(obj1);
        const Data = await ksPcApi.testHistory(obj);
        if (data.Status == 200 && Data.data.Status == 200) {
          this.analysisState = true;
          this.row.xState = true;
          this.row.submitState = true; // 检测简答题这些是否提交
        } else {
          this.$message.error("答案提交失败");
        }
      } else {
        this.$message({
          message: "警告，请填写您的答案",
          type: "warning",
        });
      }
    },
    // 题卡切换
    cardSwitch(zitem) {
      this.$nextTick(() => {
        this.anIndex = zitem.sujectIndex - 1;
        this.noteState = false;
        this.getNoteCollect();
      });
    },
    // 获取收藏和笔记状态
    async getNoteCollect() {
      const obj = {
        TestID: this.row.ID,
        ChildID: this.row.ChapterID,
        AppID: this.row.AppID,
      };
      const { data } = await ksPcApi.getNoteCollect(obj);
      if (data.Status == 200) {
        this.IsFav = data.Data.IsFav;
        this.userNote = data.Data.Context;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 培训创建的练习提交记录学分
    async creditRecord() {
      const obj = {
        type: "exercise",
        typeID: this.$parent.rowObj.ExamID,
      };
      const { data } = await training.submitCredit(obj);
      if (data.Status !== 200) {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
    },
    // 进入次数统计接口
    async buryingPoint() {
      const obj = {
        examID: this.$parent.rowObj.ExamID,
      };
      const { data } = await ksPcApi.updateExerciseLog(obj);
    },
  },
  mounted() {
    this.timer = setInterval(this.buryingPoint, 30000);
  },
  computed: {
    ProgressBar() {
      return function () {
        this.completeNum = this.userAbswerArr.length; // 已答提数
        this.num = (this.completeNum / this.planNum).toFixed(2) * 100;
        // this.num = 20;
        return this.num;
      };
    },
    submitBtn() {
      return function () {
        if (this.row) {
          if (this.row.Type == "XTEST") {
            return true;
          } else if (this.row.Type == "TKTEST") {
            return true;
          } else if (
            this.row.Type == "A3TEST" &&
            this.row.Style === "共用题干不定项选择题"
          ) {
            return true;
          } else if (this.row.Type == "BTEST" && this.row.Answer.length > 1) {
            return true;
          } else if (this.row.Type == "JDTEST") {
            return true;
          }
        } else {
          return false;
        }
      };
    },
    questionCard() {
      return function (item) {
        if (
          (item.TestType === "TKTEST" || item.TestType === "JDTEST") &&
          item.UserAnswer
        ) {
          return "blue1";
        } else {
          if (item.UserAnswer) {
            if (item.UserAnswer == item.Answer) {
              return "green1";
            } else {
              return "red1";
            }
          } else {
            return "";
          }
        }
      };
    },
    answerIndex() {
      return function (index, zindex) {
        return index + 1 + zindex;
      };
    },
  },
  watch: {
    anIndex(newValue, oldValue) {
      if (newValue !== null) {
        this.row = this.answerArr[newValue];
      }
    },
    row: {
      handler(newVal, oldVal) {
        if (newVal.UserAnswer != null) {
          if (Array.isArray(newVal.UserAnswer) == true) {
            // console.log(newVal.UserAnswer.join());
            if (newVal.UserAnswer.join()) {
              this.analysisState = true;
            } else {
              this.analysisState = false;
            }
          } else {
            if (
              this.row.Type === "XTEST" ||
              this.row.Type == "JDTEST" ||
              this.row.Type == "TKTEST" ||
              this.row.Style === "共用题干不定项选择题" ||
              this.row.Style === "多项选择题"
            ) {
              this.analysisState = this.row.xState == true ? true : false;
            } else {
              this.analysisState = true;
            }
          }
        }
      },
      // deep: true, // 开启深度监听
    },
  },
  beforeDestroy() {
    this.timer = null;
    clearInterval(this.timer);
  },
  activated() {
    this.init();
    this.buryingPoint();
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 780px;
  background: #ebecf1;
  .progress_view {
    height: 63px;
    padding: 0px 24px;
    line-height: 63px;
    display: flex;
    border: 1px solid #d1dde4;
    background: #fff;
    > p {
      font-weight: bold;
    }
    > .progress {
      height: 30px;
      margin-top: 16px;
      width: 80%;
      margin-left: 24px;
      // padding-left: 24px;
      letter-spacing: 2px;
      border: 1px solid #d1dde4;
      display: flex;
      align-items: center;
      position: relative;
      .progress_title {
        position: absolute;
        left: 18px;
      }
    }
  }
  .content_view {
    margin-top: 16px;
    height: 76vh;
    display: flex;
    .content_left {
      border: 1px solid #d1dde4;
      background: #fff;
      flex: 3;
      margin-right: 24px;
      overflow-y: auto;
    }
    .content_right {
      flex: 1;
      .botton_view {
        border: 1px solid #d1dde4;
        background: #fff;
        height: 82px;
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        > .el-button {
          margin-right: 16px;
          letter-spacing: 1px;
        }
      }
      .answer_sheet {
        border: 1px solid #d1dde4;
        background: #fff;
        height: calc(100% - 106px);
        > p {
          background: #eff3f5;
          margin: 10px 20px;
          border-radius: 5px;
          height: 60px;
          line-height: 60px;
          padding: 0px 24px;
          font-weight: bold;
          letter-spacing: 1px;
        }
        > .answer_list {
          width: 390px;
          // height: 78%;
          height: 484px;
          // overflow: hidden;
          // border: 1px solid #000;
          overflow-y: auto;
          // position: relative;
          .answer_view {
            // position: absolute;
            // top: 0;
          }
        }
        > .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 18px;
        }
      }
    }
  }
}
.Progress {
  width: 100%;
  height: 30px;
  // border: 1px solid red;
  // margin-left: 40px;
  .piece {
    height: 30px;
    line-height: 30px;
    background: #3498db;
    transition: 0.3s;
    span {
      // margin-left: 12px;
    }
  }
}
.switch_view {
  border-top: 1px solid #d1dde4;
  display: flex;
  justify-content: space-between;
  padding: 24px 0px;
  margin-left: 24px;
  margin-right: 24px;
  .switch_left {
    > .el-button {
      // height: 48px;
      background: #f4f4f4;
    }
  }
  .switch_right {
    display: flex;
    .el-button {
      position: relative;
      width: 90px;
      > span > img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 22%;
        left: 9%;
      }
      &:nth-child(2) {
        > span > img {
          width: 20px;
          height: 18px;
          position: absolute;
          top: 24%;
          left: 8%;
        }
      }
    }
  }
}
.analysis_view {
  min-height: 130px;
  margin: 24px;
  padding: 10px 20px;
  border: 1px solid #d1dde4;
  background: #eff3f5;
  > h4 {
    margin-bottom: 12px;
  }
  > div {
    display: flex;
    flex-wrap: wrap;
    > p {
      &:nth-child(1) {
        margin-right: 24px;
      }
      span {
        font-weight: bold;
      }
    }
  }
  > p {
    margin-top: 14px;
    span {
      color: #5d9cec;
      font-weight: bold;
    }
  }
}
.note_view {
  min-height: 130px;
  margin: 24px;
  padding: 10px 20px;
  border: 1px solid #d1dde4;
  background: #eff3f5;
  h4 {
    margin-bottom: 16px;
  }
  ::v-deep .el-textarea__inner {
    height: 85px;
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    > p {
      color: #7b7b7b;
    }
    > .el-button {
      width: 100px;
      letter-spacing: 2px;
      font-size: 18px;
    }
  }
}
.blue {
  background: #5d9cec;
  color: #fff;
}
.answer_card {
  padding: 16px;
  list-style: none;
  > p {
    display: flex;
    align-items: center;
    > span {
      width: 4px;
      height: 14px;
      background: #5d9cec;
      display: inline-block;
      margin-right: 4px;
    }
  }
  > .box_view {
    display: flex;
    flex-wrap: wrap;
    > div {
      margin: 7px 2px;
    }
  }
}
.box {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #dcdcdc;
  cursor: pointer;
}
.blue1 {
  background: #3498db;
  color: #fff;
}
.red1 {
  background: #ee4f3b;
  color: #fff;
}
.green1 {
  background: #01cf97;
  color: #fff;
}
</style>